"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ExtentEvent = void 0;

var _Event = _interopRequireDefault(require("../events/Event.js"));

var _Feature = _interopRequireDefault(require("../Feature.js"));

var _GeometryType = _interopRequireDefault(require("../geom/GeometryType.js"));

var _MapBrowserEventType = _interopRequireDefault(require("../MapBrowserEventType.js"));

var _Point = _interopRequireDefault(require("../geom/Point.js"));

var _Pointer = _interopRequireDefault(require("./Pointer.js"));

var _Vector = _interopRequireDefault(require("../layer/Vector.js"));

var _Vector2 = _interopRequireDefault(require("../source/Vector.js"));

var _condition = require("../events/condition.js");

var _extent = require("../extent.js");

var _coordinate = require("../coordinate.js");

var _Style = require("../style/Style.js");

var _Polygon = require("../geom/Polygon.js");

var _proj = require("../proj.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/interaction/Extent
 */


/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.always}.
 * @property {import("../extent.js").Extent} [extent] Initial extent. Defaults to no
 * initial extent.
 * @property {import("../style/Style.js").StyleLike} [boxStyle]
 * Style for the drawn extent box. Defaults to the `Polygon` editing style
 * documented in {@link module:ol/style/Style~Style}
 * @property {number} [pixelTolerance=10] Pixel tolerance for considering the
 * pointer close enough to a segment or vertex for editing.
 * @property {import("../style/Style.js").StyleLike} [pointerStyle]
 * Style for the cursor used to draw the extent. Defaults to the `Point` editing style
 * documented in {@link module:ol/style/Style~Style}
 * @property {boolean} [wrapX=false] Wrap the drawn extent across multiple maps
 * in the X direction? Only affects visuals, not functionality.
 */

/**
 * @enum {string}
 */
var ExtentEventType = {
  /**
   * Triggered after the extent is changed
   * @event ExtentEvent#extentchanged
   * @api
   */
  EXTENTCHANGED: 'extentchanged'
};
/**
 * @classdesc
 * Events emitted by {@link module:ol/interaction/Extent~Extent} instances are
 * instances of this type.
 */

var ExtentEvent =
/** @class */
function (_super) {
  __extends(ExtentEvent, _super);
  /**
   * @param {import("../extent.js").Extent} extent the new extent
   */


  function ExtentEvent(extent) {
    var _this = _super.call(this, ExtentEventType.EXTENTCHANGED) || this;
    /**
     * The current extent.
     * @type {import("../extent.js").Extent}
     * @api
     */


    _this.extent = extent;
    return _this;
  }

  return ExtentEvent;
}(_Event["default"]);

exports.ExtentEvent = ExtentEvent;

/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'extentchanged', ExtentEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'extentchanged', Return>} ExtentOnSignature
 */

/**
 * @classdesc
 * Allows the user to draw a vector box by clicking and dragging on the map.
 * Once drawn, the vector box can be modified by dragging its vertices or edges.
 * This interaction is only supported for mouse devices.
 *
 * @fires ExtentEvent
 * @api
 */
var Extent =
/** @class */
function (_super) {
  __extends(Extent, _super);
  /**
   * @param {Options} [opt_options] Options.
   */


  function Extent(opt_options) {
    var _this = this;

    var options = opt_options || {};
    _this = _super.call(this,
    /** @type {import("./Pointer.js").Options} */
    options) || this;
    /***
     * @type {ExtentOnSignature<import("../events").EventsKey>}
     */

    _this.on;
    /***
     * @type {ExtentOnSignature<import("../events").EventsKey>}
     */

    _this.once;
    /***
     * @type {ExtentOnSignature<void>}
     */

    _this.un;
    /**
     * Condition
     * @type {import("../events/condition.js").Condition}
     * @private
     */

    _this.condition_ = options.condition ? options.condition : _condition.always;
    /**
     * Extent of the drawn box
     * @type {import("../extent.js").Extent}
     * @private
     */

    _this.extent_ = null;
    /**
     * Handler for pointer move events
     * @type {function (import("../coordinate.js").Coordinate): import("../extent.js").Extent|null}
     * @private
     */

    _this.pointerHandler_ = null;
    /**
     * Pixel threshold to snap to extent
     * @type {number}
     * @private
     */

    _this.pixelTolerance_ = options.pixelTolerance !== undefined ? options.pixelTolerance : 10;
    /**
     * Is the pointer snapped to an extent vertex
     * @type {boolean}
     * @private
     */

    _this.snappedToVertex_ = false;
    /**
     * Feature for displaying the visible extent
     * @type {Feature}
     * @private
     */

    _this.extentFeature_ = null;
    /**
     * Feature for displaying the visible pointer
     * @type {Feature<Point>}
     * @private
     */

    _this.vertexFeature_ = null;

    if (!opt_options) {
      opt_options = {};
    }
    /**
     * Layer for the extentFeature
     * @type {VectorLayer}
     * @private
     */


    _this.extentOverlay_ = new _Vector["default"]({
      source: new _Vector2["default"]({
        useSpatialIndex: false,
        wrapX: !!opt_options.wrapX
      }),
      style: opt_options.boxStyle ? opt_options.boxStyle : getDefaultExtentStyleFunction(),
      updateWhileAnimating: true,
      updateWhileInteracting: true
    });
    /**
     * Layer for the vertexFeature
     * @type {VectorLayer}
     * @private
     */

    _this.vertexOverlay_ = new _Vector["default"]({
      source: new _Vector2["default"]({
        useSpatialIndex: false,
        wrapX: !!opt_options.wrapX
      }),
      style: opt_options.pointerStyle ? opt_options.pointerStyle : getDefaultPointerStyleFunction(),
      updateWhileAnimating: true,
      updateWhileInteracting: true
    });

    if (opt_options.extent) {
      _this.setExtent(opt_options.extent);
    }

    return _this;
  }
  /**
   * @param {import("../pixel.js").Pixel} pixel cursor location
   * @param {import("../PluggableMap.js").default} map map
   * @return {import("../coordinate.js").Coordinate|null} snapped vertex on extent
   * @private
   */


  Extent.prototype.snapToVertex_ = function (pixel, map) {
    var pixelCoordinate = map.getCoordinateFromPixelInternal(pixel);

    var sortByDistance = function sortByDistance(a, b) {
      return (0, _coordinate.squaredDistanceToSegment)(pixelCoordinate, a) - (0, _coordinate.squaredDistanceToSegment)(pixelCoordinate, b);
    };

    var extent = this.getExtentInternal();

    if (extent) {
      //convert extents to line segments and find the segment closest to pixelCoordinate
      var segments = getSegments(extent);
      segments.sort(sortByDistance);
      var closestSegment = segments[0];
      var vertex = (0, _coordinate.closestOnSegment)(pixelCoordinate, closestSegment);
      var vertexPixel = map.getPixelFromCoordinateInternal(vertex); //if the distance is within tolerance, snap to the segment

      if ((0, _coordinate.distance)(pixel, vertexPixel) <= this.pixelTolerance_) {
        //test if we should further snap to a vertex
        var pixel1 = map.getPixelFromCoordinateInternal(closestSegment[0]);
        var pixel2 = map.getPixelFromCoordinateInternal(closestSegment[1]);
        var squaredDist1 = (0, _coordinate.squaredDistance)(vertexPixel, pixel1);
        var squaredDist2 = (0, _coordinate.squaredDistance)(vertexPixel, pixel2);
        var dist = Math.sqrt(Math.min(squaredDist1, squaredDist2));
        this.snappedToVertex_ = dist <= this.pixelTolerance_;

        if (this.snappedToVertex_) {
          vertex = squaredDist1 > squaredDist2 ? closestSegment[1] : closestSegment[0];
        }

        return vertex;
      }
    }

    return null;
  };
  /**
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent pointer move event
   * @private
   */


  Extent.prototype.handlePointerMove_ = function (mapBrowserEvent) {
    var pixel = mapBrowserEvent.pixel;
    var map = mapBrowserEvent.map;
    var vertex = this.snapToVertex_(pixel, map);

    if (!vertex) {
      vertex = map.getCoordinateFromPixelInternal(pixel);
    }

    this.createOrUpdatePointerFeature_(vertex);
  };
  /**
   * @param {import("../extent.js").Extent} extent extent
   * @return {Feature} extent as featrue
   * @private
   */


  Extent.prototype.createOrUpdateExtentFeature_ = function (extent) {
    var extentFeature = this.extentFeature_;

    if (!extentFeature) {
      if (!extent) {
        extentFeature = new _Feature["default"]({});
      } else {
        extentFeature = new _Feature["default"]((0, _Polygon.fromExtent)(extent));
      }

      this.extentFeature_ = extentFeature;
      this.extentOverlay_.getSource().addFeature(extentFeature);
    } else {
      if (!extent) {
        extentFeature.setGeometry(undefined);
      } else {
        extentFeature.setGeometry((0, _Polygon.fromExtent)(extent));
      }
    }

    return extentFeature;
  };
  /**
   * @param {import("../coordinate.js").Coordinate} vertex location of feature
   * @return {Feature} vertex as feature
   * @private
   */


  Extent.prototype.createOrUpdatePointerFeature_ = function (vertex) {
    var vertexFeature = this.vertexFeature_;

    if (!vertexFeature) {
      vertexFeature = new _Feature["default"](new _Point["default"](vertex));
      this.vertexFeature_ = vertexFeature;
      this.vertexOverlay_.getSource().addFeature(vertexFeature);
    } else {
      var geometry = vertexFeature.getGeometry();
      geometry.setCoordinates(vertex);
    }

    return vertexFeature;
  };
  /**
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   */


  Extent.prototype.handleEvent = function (mapBrowserEvent) {
    if (!mapBrowserEvent.originalEvent || !this.condition_(mapBrowserEvent)) {
      return true;
    } //display pointer (if not dragging)


    if (mapBrowserEvent.type == _MapBrowserEventType["default"].POINTERMOVE && !this.handlingDownUpSequence) {
      this.handlePointerMove_(mapBrowserEvent);
    } //call pointer to determine up/down/drag


    _super.prototype.handleEvent.call(this, mapBrowserEvent); //return false to stop propagation


    return false;
  };
  /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */


  Extent.prototype.handleDownEvent = function (mapBrowserEvent) {
    var pixel = mapBrowserEvent.pixel;
    var map = mapBrowserEvent.map;
    var extent = this.getExtentInternal();
    var vertex = this.snapToVertex_(pixel, map); //find the extent corner opposite the passed corner

    var getOpposingPoint = function getOpposingPoint(point) {
      var x_ = null;
      var y_ = null;

      if (point[0] == extent[0]) {
        x_ = extent[2];
      } else if (point[0] == extent[2]) {
        x_ = extent[0];
      }

      if (point[1] == extent[1]) {
        y_ = extent[3];
      } else if (point[1] == extent[3]) {
        y_ = extent[1];
      }

      if (x_ !== null && y_ !== null) {
        return [x_, y_];
      }

      return null;
    };

    if (vertex && extent) {
      var x = vertex[0] == extent[0] || vertex[0] == extent[2] ? vertex[0] : null;
      var y = vertex[1] == extent[1] || vertex[1] == extent[3] ? vertex[1] : null; //snap to point

      if (x !== null && y !== null) {
        this.pointerHandler_ = getPointHandler(getOpposingPoint(vertex)); //snap to edge
      } else if (x !== null) {
        this.pointerHandler_ = getEdgeHandler(getOpposingPoint([x, extent[1]]), getOpposingPoint([x, extent[3]]));
      } else if (y !== null) {
        this.pointerHandler_ = getEdgeHandler(getOpposingPoint([extent[0], y]), getOpposingPoint([extent[2], y]));
      } //no snap - new bbox

    } else {
      vertex = map.getCoordinateFromPixelInternal(pixel);
      this.setExtent([vertex[0], vertex[1], vertex[0], vertex[1]]);
      this.pointerHandler_ = getPointHandler(vertex);
    }

    return true; //event handled; start downup sequence
  };
  /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   */


  Extent.prototype.handleDragEvent = function (mapBrowserEvent) {
    if (this.pointerHandler_) {
      var pixelCoordinate = mapBrowserEvent.coordinate;
      this.setExtent(this.pointerHandler_(pixelCoordinate));
      this.createOrUpdatePointerFeature_(pixelCoordinate);
    }
  };
  /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */


  Extent.prototype.handleUpEvent = function (mapBrowserEvent) {
    this.pointerHandler_ = null; //If bbox is zero area, set to null;

    var extent = this.getExtentInternal();

    if (!extent || (0, _extent.getArea)(extent) === 0) {
      this.setExtent(null);
    }

    return false; //Stop handling downup sequence
  };
  /**
   * Remove the interaction from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../PluggableMap.js").default} map Map.
   */


  Extent.prototype.setMap = function (map) {
    this.extentOverlay_.setMap(map);
    this.vertexOverlay_.setMap(map);

    _super.prototype.setMap.call(this, map);
  };
  /**
   * Returns the current drawn extent in the view projection (or user projection if set)
   *
   * @return {import("../extent.js").Extent} Drawn extent in the view projection.
   * @api
   */


  Extent.prototype.getExtent = function () {
    return (0, _proj.toUserExtent)(this.getExtentInternal(), this.getMap().getView().getProjection());
  };
  /**
   * Returns the current drawn extent in the view projection
   *
   * @return {import("../extent.js").Extent} Drawn extent in the view projection.
   * @api
   */


  Extent.prototype.getExtentInternal = function () {
    return this.extent_;
  };
  /**
   * Manually sets the drawn extent, using the view projection.
   *
   * @param {import("../extent.js").Extent} extent Extent
   * @api
   */


  Extent.prototype.setExtent = function (extent) {
    //Null extent means no bbox
    this.extent_ = extent ? extent : null;
    this.createOrUpdateExtentFeature_(extent);
    this.dispatchEvent(new ExtentEvent(this.extent_));
  };

  return Extent;
}(_Pointer["default"]);
/**
 * Returns the default style for the drawn bbox
 *
 * @return {import("../style/Style.js").StyleFunction} Default Extent style
 */


function getDefaultExtentStyleFunction() {
  var style = (0, _Style.createEditingStyle)();
  return function (feature, resolution) {
    return style[_GeometryType["default"].POLYGON];
  };
}
/**
 * Returns the default style for the pointer
 *
 * @return {import("../style/Style.js").StyleFunction} Default pointer style
 */


function getDefaultPointerStyleFunction() {
  var style = (0, _Style.createEditingStyle)();
  return function (feature, resolution) {
    return style[_GeometryType["default"].POINT];
  };
}
/**
 * @param {import("../coordinate.js").Coordinate} fixedPoint corner that will be unchanged in the new extent
 * @return {function (import("../coordinate.js").Coordinate): import("../extent.js").Extent} event handler
 */


function getPointHandler(fixedPoint) {
  return function (point) {
    return (0, _extent.boundingExtent)([fixedPoint, point]);
  };
}
/**
 * @param {import("../coordinate.js").Coordinate} fixedP1 first corner that will be unchanged in the new extent
 * @param {import("../coordinate.js").Coordinate} fixedP2 second corner that will be unchanged in the new extent
 * @return {function (import("../coordinate.js").Coordinate): import("../extent.js").Extent|null} event handler
 */


function getEdgeHandler(fixedP1, fixedP2) {
  if (fixedP1[0] == fixedP2[0]) {
    return function (point) {
      return (0, _extent.boundingExtent)([fixedP1, [point[0], fixedP2[1]]]);
    };
  } else if (fixedP1[1] == fixedP2[1]) {
    return function (point) {
      return (0, _extent.boundingExtent)([fixedP1, [fixedP2[0], point[1]]]);
    };
  } else {
    return null;
  }
}
/**
 * @param {import("../extent.js").Extent} extent extent
 * @return {Array<Array<import("../coordinate.js").Coordinate>>} extent line segments
 */


function getSegments(extent) {
  return [[[extent[0], extent[1]], [extent[0], extent[3]]], [[extent[0], extent[3]], [extent[2], extent[3]]], [[extent[2], extent[3]], [extent[2], extent[1]]], [[extent[2], extent[1]], [extent[0], extent[1]]]];
}

var _default = Extent;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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